function LookbookSlider(sectionId, controlsContainerSelector, carouselSpacing) {
  let slider = null;
  let sectionElement = document.querySelector(`#shopify-section-${sectionId}`);
  let controlsContainer = sectionElement.querySelector(
    controlsContainerSelector
  );

  if (!sectionElement || !controlsContainer) {
    console.error(
      `Required elements not found for section with ID: ${sectionId}`
    );
    return;
  }

  function init() {
    const prevSlide = controlsContainer.querySelector(".prev-slide");
    const nextSlide = controlsContainer.querySelector(".next-slide");

    slider = new KeenSlider(`#lookbook-slider-${sectionId}`, {
      loop: true,
      drag: true,
      breakpoints: {
        "(min-width: 320px)": {
          slides: { perView: 1.5, spacing: carouselSpacing },
        },
        "(min-width: 768px)": {
          slides: { perView: 3, spacing: carouselSpacing },
        },
        "(min-width: 1024px)": {
          slides: { perView: 5.5, spacing: carouselSpacing },
        },
      },
      slides: { perView: 1.5, spacing: carouselSpacing },
    });

    prevSlide.addEventListener("click", () => slider.prev());
    nextSlide.addEventListener("click", () => slider.next());
  }

  function destroy() {
    if (slider) {
      slider.destroy();
      slider = null;
      sectionElement = null;
      controlsContainer = null;
    }
  }

  // Call the init function when creating a new instance
  init();

  // Add the init and destroy functions to the prototype
  this.init = init;
  this.destroy = destroy;
}
